// ============================================================
// BLACK OWL - Typography
// ============================================================
// FONT_BODY: all body and UI text (Inter).
// FONT_DISPLAY: the "BLACK OWL" wordmark and major screen
// headers only (Oswald). Both load from Google Fonts in
// public/index.html.
// ============================================================

export const FONT_BODY =
  "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";

export const FONT_DISPLAY = "'Oswald', 'Arial Narrow', 'Helvetica Neue', sans-serif";

// FB-16: one line, cut with "…". In a flex row the element (or its flex
// parent) also needs minWidth: 0 so it can shrink below its text width.
export const ELLIPSIS = {
  whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", minWidth: 0,
};
